import { Fragment, useEffect, useRef, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import {
  calculateDateDiff,
  calculateDateDiffWithGrace,
  capitalizeFirstLetter,
  classNames,
  disabledIfFieldChecker,
  findDataInFields,
  findDataInObject,
  formatDateWithTime,
  fromUtcToBranchTime,
} from "../../utils/helperFuctions";
import { formatInput2 } from "../../utils/helperFuctions";
import InputText from "../InputFields/InputText/InputText";
import InputToggle from "../InputFields/InputToggle/InputToggle";
import PopUp from "../PopUp/PopUp";
import { useSelector } from "react-redux";
import { config } from "../../utils/config";
import axios from "axios";
import { getCookie } from "../../utils/cookieHandler";
import InputCalc from "./InputCalc";

const statuses = {
  Fixed: "text-green-700 bg-green-50 ring-green-600/20",
  Pending: "text-gray-600 bg-gray-50 ring-gray-500/10",
  //Archived: 'text-yellow-800 bg-yellow-50 ring-yellow-600/20',
};

const isTaxed = (val) =>
  val === true || val === "true" || val === 1 || val === "1";

export default function CardList({
  mainAction,
  rowActions,
  data,
  actionClicked,
  name,
  inputField,
  handleInputChange,
  rowActionsShowNew,
  forceReloadFunction,
  isFieldDisabled,
  removeValueOnWhichFieldValueChange,
  calculateTotalAmount,
  lazyload,
  lazyloadParam,
  disableWhenDayEnds,
  scroll,
  id,
  onlyLatestCanBeDeleted,
  handleSubmit,
  callPopUp,
  useIndexAsKey,
  lockStatus,
  isLocked,
  fieldName,
}) {
  const currentRole = getCookie("_r");
  const isAdmin = process.env.REACT_APP_ADMIN_ROLE === currentRole;
  const currentFields = useSelector((state) => state.showFields);
  const BranchCode = findDataInFields(currentFields, "branch.code");
  const [calcByIndex, setCalcByIndex] = useState({});
  const [emailSendLoading, setEmailSendLoading] = useState({
    loading: false,
    id: null,
  });

  const calculateDaysAmount = (index) => {
    const dateExtended = data[index]["dateExtended"];
    const returnDate =
      data != null &&
      Array.isArray(data) === true &&
      data.length > 0 &&
      data[index + 1] != null
        ? data[index + 1].dateExtended
        : findDataInFields(currentFields, "return_date");
    let d1 = returnDate;
    if (d1.endsWith("Z") === true) {
      d1 = d1.substring(0, d1.length - 1);
    }
    let d2 = dateExtended;
    if (d2.endsWith("Z") === true) {
      d2 = d2.substring(0, d2.length - 1);
    }

    const dateDiff = calculateDateDiff(d1, d2);

    return dateDiff;
  };
  const calculateTotal = (index) => {
    // console.log(dateExtended, "dateExtended");

    const amount = calculateDaysAmount(index);
    // data[index].days = `${amount}`;
    // console.log(amount);

    const rate = data[index][calculateTotalAmount.rateField];
    // console.log(data, "asd");

    if (
      data[index].total != null &&
      data[index].total !== "" &&
      data[index].total !== "null"
    ) {
      return data[index].total;
    } else if (rate === "" || rate == null || rate === "null") {
      return null;
    }

    const total = amount * rate;

    return total;
  };

  const [popupData, setpopupData] = useState({});
  const clearAllBtnRef = useRef(null);

  // todo: do it the other correct way like popupselection
  const defaultValueGetter = () => {
    if (removeValueOnWhichFieldValueChange != null) {
      const defaultValue = findDataInFields(
        currentFields,
        removeValueOnWhichFieldValueChange
      );
      return defaultValue;
    }
    return null;
  };
  const branchDefaultValue = defaultValueGetter();
  const [fieldDefaultValue, setFieldDefaultValue] =
    useState(branchDefaultValue);
  useEffect(() => {
    if (removeValueOnWhichFieldValueChange != null) {
      if (fieldDefaultValue !== branchDefaultValue) {
        if (clearAllBtnRef.current != null) {
          clearAllBtnRef.current.click();
          setFieldDefaultValue(branchDefaultValue);
        }
      }
    }
  }, [branchDefaultValue]);
  const handleActionClick = async (e, skipPopup, item) => {
    e.preventDefault();
    const tempID = e.target.dataset?.id;
    const tempID2 = e.target.dataset?.tempid;
    if ((tempID || tempID2) && e.target.name !== "view") {
      const action = e.target.name;
      const actionName = e.target.title;
      if (action === "update") {
        if (actionName === "Delete") {
          if (skipPopup === true) {
            const tempData1 =
              mainAction?.name === actionName && mainAction?.id === action
                ? mainAction?.data
                : Array.isArray(rowActions)
                ? rowActions.find(
                    (x) => x.name === actionName && x.id === action
                  )
                : null;

            if (tempData1 && tempData1.data) {
              actionClicked(
                { ...tempData1.data, id: tempID, tempid: tempID2 },
                name,
                action
              );
            }
          } else {
            setpopupData({
              title: "Deleting data",
              description: "Are you sure you want to delete?",
              takeActionText: "Delete",
              takeActionFun: () => {
                const tempData1 =
                  mainAction?.name === actionName && mainAction?.id === action
                    ? mainAction?.data
                    : Array.isArray(rowActions)
                    ? rowActions.find(
                        (x) => x.name === actionName && x.id === action
                      )
                    : null;

                if (tempData1 && tempData1.data) {
                  actionClicked(
                    { ...tempData1.data, id: tempID, tempid: tempID2 },
                    name,
                    action
                  );
                }
              },
              showPopUp: true,
            });
          }
        } else {
          const tempData1 =
            mainAction?.name === actionName && mainAction?.id === action
              ? mainAction?.data
              : Array.isArray(rowActions)
              ? rowActions.find((x) => x.name === actionName && x.id === action)
              : null;

          if (tempData1 && tempData1.data) {
            actionClicked(
              { ...tempData1.data, id: tempID, tempid: tempID2 },
              name,
              action
            );
          }
        }
      } else if (action === "gen-rec") {
        await handleSubmit(e);
        const response = await axios.get(
          `${config.apiUrl}/api/auth/pdf-token`,
          {
            headers: { Authorization: `Bearer ${getCookie("_AT")}` },
          }
        );

        const tempToken = response.data.token;

        const pdfUrl = `${config.apiUrl}/api/reservations/transactionreceipt/${item.id}?access_token=${tempToken}`;

        window.open(`${pdfUrl}`, "_blank");
      } else if (action === "email-rec") {
        await handleSubmit(e);
        setEmailSendLoading({ loading: true, id: item.id });
        const res = await fetch(
          `${config.apiUrl}/api/reservations/sharetransactionreceiptemail/${item.id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${getCookie("_AT")}`,
            },
          }
        );

        const result = await res.json();

        if (callPopUp instanceof Function && result.success === true) {
          callPopUp({
            title: "Email Sent Successfully",
            description: `The transaction has been sent to ${findDataInFields(
              currentFields,
              "contact.email"
            )}.`,
            showPopUp: true,
            hideCancel: true,
          });
        }

        setEmailSendLoading({ loading: false, id: null });
        if (result.error != null) {
          if (callPopUp instanceof Function) {
            callPopUp({
              title: "Error ",
              description: "Contract not generated.",
              isError: true,
              showPopUp: true,
              hideCancel: true,
            });
          }
        }
      } else {
        const sendData = data.find((x) => x.id === tempID);
        if (sendData) {
          actionClicked(sendData, name, action);
        }
      }
    } else {
      const sendData = data.find((x) => x.id === tempID);
      if (sendData) {
        actionClicked(sendData, name, e.target.name);
      }
    }
  };

  const inputhandleChange = (e) => {
    console.log(e);

    //e.preventDefault();
    const tempID = e.target.dataset?.id;
    const isNew = e.target.dataset?.isnew;
    const _name = e.target.name;
    //console.log('tt:',tempID,isNew,_name)
    const objtoAdd = tempID
      ? isNew
        ? { tempid: tempID, [_name]: e.target.value }
        : { id: tempID, [_name]: e.target.value }
      : { [_name]: e.target.value };
    if (_name) {
      actionClicked(objtoAdd, name, "update");
    }
  };

  const forceReloadInputFunction = (e) => {
    if (forceReloadFunction instanceof Function) forceReloadFunction(e);
  };

  // Map fieldName to lockStatus key
  const fieldToLockKey = {
    'charges': 'charges',
    'transactions': 'transactions',
    'reservation_addons': 'addons',
    'reservation_addons2': 'addons',
    'time_extension': 'timeAdjustments',
    'custom_orders': 'customOrders',
  };

  // Get lock info for item from lockStatus
  const getLockInfo = (item) => {
    if (!lockStatus || !item.id) return null;
    const key = fieldToLockKey[fieldName];
    if (!key || !lockStatus[key]) return null;
    const info = lockStatus[key][item.id];
    if (!info) return null;
    if (typeof info === 'boolean') return { locked: info };
    return info;
  };

  // Check if item is locked based on billing event status
  const getIfItemIsLocked = (i, item) => {
    // If isLocked function is provided, use it to check lock status
    if (isLocked && typeof isLocked === 'function') {
      return isLocked(item, fieldName);
    }
    const info = getLockInfo(item);
    return info?.locked === true;
  };

  // Check if this item should be FORCE locked (no admin bypass)
  const shouldForceLock = (item) => {
    return true; // Force admin to change values in directus to avoid making vat/sequence errors.
    const lockInfo = getLockInfo(item);
    
    // Extension/Reduction items are always locked for everyone
    const adjustmentType = item.adjustmentType?.toLowerCase();
    if (adjustmentType === 'extension' || adjustmentType === 'reduction') {
      return true;
    }
    
    // Rental Days and VAT are always locked for everyone
    const billingType = lockInfo?.type?.toLowerCase() || '';
    if (billingType.includes('rental days') || billingType.includes('vat')) {
      return true;
    }
    
    // Discount and Additional Discount are always locked for everyone (including admin)
    // to preserve historical VAT allocation decisions
    if (billingType.includes('discount') || billingType.includes('additional discount')) {
      return true;
    }
    
    // Non-credit-note items with negative amounts are always locked
    if (lockInfo && lockInfo.is_credit_note === false && parseFloat(lockInfo.amount || 0) < 0) {
      return true;
    }
    
    // return false; //returning true early to avoid if checks, keeping code for easy revert.
   
  };

  // Check if item should be disabled based on billing event lock status
  const getIfisDisabledWhenDayEnds = (i, item, forAmountInput = false) => {
    if (disableWhenDayEnds !== true) return false;
    
    const forceLocked = shouldForceLock(item);
    const itemIsLocked = getIfItemIsLocked(i, item);
    
    // Force locked items (Extension/Reduction/Rental Days/VAT/negative non-credit-note)
    // are locked for everyone including admin when billing event is locked
    if (forceLocked && itemIsLocked) {
      return true;
    }
    
    // If billing event is not locked, allow editing
    if (!itemIsLocked) return false;
    
    // Admin can edit amounts on locked items that are not force-locked
    // (e.g., mileage, coverage, discount, delivery charges, security deposit)
    if (isAdmin && forAmountInput) {
      return false;
    }
    
    return true;
  };

  let ulStyle = {};
  if (scroll === true) {
    ulStyle = {
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "hidden",
    };
  }

  return (
    <ul role="list" className="divide-y divide-gray-100" style={ulStyle}>
      <button
        className="hidden"
        ref={clearAllBtnRef}
        onClick={(e) => {
          e.preventDefault();
          data.forEach((item) => {
            handleActionClick(
              {
                preventDefault: e.preventDefault,
                target: {
                  dataset: {
                    id: item.id,
                    tempid: item.tempid,
                  },
                  name: "update",
                  title: "Delete",
                },
              },
              true
            );
          });
        }}
      >
        clear all
      </button>
      {data &&
        data.map((item, i) => {
          return (
            <li
              key={
                useIndexAsKey === true
                  ? i
                  : `${item.id ?? item.tempid}-${item.createdOn ?? ""}`
              }
              className={`flex items-center justify-between gap-x-6 py-5 px-4 ${
                item.delete === "true" ? "bg-red-300" : ""
              }`}
            >
              <div className="min-w-[30%]">
                <div className="flex items-start gap-x-3">
                  {item.title && (
                    <p className="text-sm font-semibold leading-6 text-gray-900">
                      {item.dateExtended != null && BranchCode != null ? (
                        <div key={item.id} className="mb-2">
                          <p className="text-sm font-semibold leading-6 text-gray-900">
                            From:{" "}
                            {formatDateWithTime(
                              data != null &&
                                Array.isArray(data) === true &&
                                data.length > 0 &&
                                data[i + 1] != null
                                ? data[i + 1].dateExtended
                                : findDataInFields(
                                    currentFields,
                                    "return_date"
                                  ),
                              BranchCode
                            )}
                          </p>
                          <p className="text-sm font-semibold leading-6 text-gray-900">
                            To:{" "}
                            {formatDateWithTime(item.dateExtended, BranchCode)}
                          </p>
                          {item.adjustmentType != null && (
                            <p className="text-xs text-[#6B7280]">
                              {capitalizeFirstLetter(item.adjustmentType)}
                            </p>
                          )}
                        </div>
                      ) : (
                        item.title
                      )}
                    </p>
                  )}

                  {item.status && item.status !== "null" && (
                    <p
                      className={classNames(
                        statuses[item.status],
                        "rounded-md whitespace-nowrap mt-0.5 px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset"
                      )}
                    >
                      {item.status}
                    </p>
                  )}

                  {(name === "charges" ||
                    (item.taxable !== undefined &&
                      item.taxable !== null &&
                      item.taxable !== "")) && (
                    <p
                      className={classNames(
                        isTaxed(
                          item.taxable !== undefined &&
                            item.taxable !== null &&
                            item.taxable !== ""
                            ? item.taxable
                            : item.value?.taxable
                        )
                          ? "text-green-700 bg-green-50 ring-green-600/20"
                          : "text-gray-600 bg-gray-50 ring-gray-500/10",
                        "rounded-md whitespace-nowrap mt-0.5 px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset"
                      )}
                    >
                      {isTaxed(
                        item.taxable !== undefined &&
                          item.taxable !== null &&
                          item.taxable !== ""
                          ? item.taxable
                          : item.value?.taxable
                      )
                        ? "Taxed"
                        : "Not Taxed"}
                    </p>
                  )}
                </div>
                {item.reference != null &&
                  item.reference !== "null" &&
                  item.reference.trim() !== "" && (
                    <div className="flex gap-1 text-xs text-gray-500 font-medium">
                      <div>Ref:</div>
                      <div>{item.reference}</div>
                    </div>
                  )}
                {item.createdOn != null &&
                  item.createdBy != null &&
                  item.createdOn.trim() != "" &&
                  item.createdBy.trim() != "" &&
                  item.createdOn.trim() != "null" &&
                  item.createdBy.trim() != "null" && (
                    <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
                      {item.createdOn != "null" && (
                        <p className="whitespace-nowrap">
                          Created on{" "}
                          <time dateTime={item.createdOn}>
                            {formatInput2(item.createdOn)}
                          </time>
                        </p>
                      )}
                      <svg
                        viewBox="0 0 2 2"
                        className="h-0.5 w-0.5 fill-current"
                      >
                        <circle cx={1} cy={1} r={1} />
                      </svg>
                      {item.createdBy != null &&
                        item.createdBy.trim() != "" && (
                          <p className="truncate"> by {item.createdBy}</p>
                        )}
                      {item.image != null && item.image.trim() !== "" && (
                        <div className="flex gap-2 items-center">
                          <svg
                            viewBox="0 0 2 2"
                            className="h-0.5 w-0.5 fill-current"
                          >
                            <circle cx={1} cy={1} r={1} />
                          </svg>
                          <a
                            target="_blank"
                            href={`${config.apiUrl}/assets/${item.image}`}
                          >
                            View image
                          </a>
                        </div>
                      )}
                    </div>
                  )}
                {item.description && (
                  <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
                    <p className="whitespace-nowrap">{item.description}</p>
                  </div>
                )}
                {/* to add url here */}
              </div>
              <div className="flex items-center gap-x-4">
                {!item.new && mainAction && (
                  <a
                    href={"#"}
                    onClick={(e) => {
                      handleActionClick(e, undefined);
                    }}
                    name={mainAction?.id}
                    title={mainAction?.name}
                    data-id={item.id}
                    className={`hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block ${
                      item.new ? "pointer-events-none" : ""
                    }`}
                  >
                    {mainAction ? mainAction?.name ?? "Veiw" : "Veiw"}
                    <span className="sr-only">, {item.title}</span>
                  </a>
                )}
                {calculateTotalAmount != null && (
                  <InputCalc
                    i={i}
                    item={item}
                    inputField={inputField}
                    calculateDaysAmount={calculateDaysAmount}
                    getIfisDisabledWhenDayEnds={getIfisDisabledWhenDayEnds}
                    returnedValue={(val) => {
                      setCalcByIndex((prev) => ({ ...prev, [i]: val }));

                      let target = {
                        target: {
                          name: inputField.name,
                          value: val,
                          dataset: {
                            id:
                              item.id != null && item.id.trim() !== ""
                                ? item.id
                                : item.tempid,
                          },
                        },
                      };
                      if (item.id == null || item.id.trim() === "") {
                        target.target.dataset.isnew = "true";
                      }
                      inputhandleChange(target);
                    }}
                  />
                )}

                {inputField && inputField?.type !== "toggle" && (
                  <InputText
                    lazyloadUrl={
                      // item.rate == null ||
                      // item.rate === "" ||
                      // item.rate === "null"
                      //   ? lazyload
                      //   : undefined
                      lazyload
                    }
                    getInitialPriceOnFieldChange={
                      inputField?.getInitialPriceOnFieldChange
                    }
                    lazyloadParam={lazyloadParam}
                    name={inputField?.name}
                    dataid={
                      item.id && item.id !== "undefined" ? item.id : item.tempid
                    }
                    body={
                      calculateTotalAmount != null &&
                      calculateTotalAmount.lazyloadFormValues != null &&
                      !isNaN(parseInt(calculateDaysAmount(i)))
                        ? {
                            fromFields: {
                              ...calculateTotalAmount.lazyloadFormValues,
                              days: parseFloat(calculateDaysAmount(i)),
                              reservationId: parseInt(id),
                            },
                            takeLiteralValueForField: ["days", "reservationId"],
                          }
                        : undefined
                    }
                    disabledIfField={inputField.disabledIfField}
                    decimalCount={inputField.decimalCount}
                    dataisnew={item.new}
                    defaultValue={
                      calculateTotalAmount != null
                        ? item?.new === true ||
                          item.id == null ||
                          item.id.trim() === ""
                          ? calculateTotal(i)
                          : calcByIndex[i] !== undefined &&
                            calcByIndex[i] !== ""
                          ? calcByIndex[i]
                          : calculateTotal(i)
                        : item?.inputValue
                    }
                    type={inputField?.type}
                    handleChange={inputhandleChange}
                    dataItem={item}
                    label2={inputField.label}
                    disabled={getIfisDisabledWhenDayEnds(i, item, true)}
                    // Admin can force update amounts even when locked
                    minValue={inputField.minValue}
                    maxValue={item.limit}
                    forceReloadIcon={inputField.forceReloadIcon}
                    forceReloadFunction={forceReloadInputFunction}
                  />
                )}
                {inputField && inputField?.type === "toggle" && (
                  <InputToggle
                    name={inputField?.name}
                    dataid={
                      item.id && item.id !== "undefined" ? item.id : item.tempid
                    }
                    disabledIfField={inputField.disabledIfField}
                    dataisnew={item.new}
                    defaultValue={item?.inputValue}
                    type={inputField?.type}
                    handleChange={inputhandleChange}
                    dataItem={item}
                    label2={inputField.label}
                    disabled={inputField.disabled}
                    currentFields={currentFields}
                  />
                )}
                {(!item.new || rowActionsShowNew) && rowActions && (
                  <Menu as="div" className="relative flex-none">
                    {getIfisDisabledWhenDayEnds(i, item) === false &&
                      (onlyLatestCanBeDeleted == null ||
                        (onlyLatestCanBeDeleted === true && i === 0)) && (
                        <Menu.Button className="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900">
                          <span className="sr-only">Open options</span>
                          {emailSendLoading.loading === true &&
                          emailSendLoading.id === item.id ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="animate-spin h-5 w-5"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="#5729BC"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                            </svg>
                          ) : (
                            <EllipsisVerticalIcon
                              className="h-5 w-5"
                              aria-hidden="true"
                            />
                          )}
                        </Menu.Button>
                      )}
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="whitespace-nowrap absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                        {rowActions.map((menuItem) => {
                          if (getIfisDisabledWhenDayEnds(i, item) === true) {
                            if (
                              menuItem.name === "Delete" ||
                              menuItem.name === "Edit"
                            ) {
                              return null;
                            }
                          }

                          return (
                            <Menu.Item key={menuItem.name}>
                              {({ active }) => {
                                return (
                                  <a
                                    href={
                                      menuItem && menuItem.id === "link"
                                        ? menuItem.url
                                        : ""
                                    }
                                    onClick={(e) => {
                                      handleActionClick(e, undefined, item);
                                    }}
                                    name={menuItem?.id}
                                    title={menuItem?.name}
                                    data-id={item.id}
                                    data-tempid={item.tempid}
                                    className={classNames(
                                      active ? "bg-gray-50" : "",
                                      "block px-3 py-1 text-sm leading-6 text-gray-900"
                                    )}
                                  >
                                    {menuItem.name}
                                    <span className="sr-only">
                                      , {menuItem.name}
                                    </span>
                                  </a>
                                );
                              }}
                            </Menu.Item>
                          );
                        })}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                )}
              </div>
            </li>
          );
        })}
      <PopUp
        isError={popupData.isError}
        title={popupData.title}
        description={popupData.description}
        formOptions={popupData.formOptions}
        takeActionText={popupData.takeActionText}
        takeActionFun={popupData.takeActionFun}
        showPopUp={popupData.showPopUp}
        hidePopUp={() => {
          setpopupData({});
        }}
        formSubmit={popupData.formSubmit}
        formConcatData={popupData.formConcatData}
        propName={popupData.propName}
        disabledForm={popupData.disabledForm}
        hideCancel={popupData.hideCancel}
        hideMainButton={popupData.hideMainButton}
        showLoading={popupData.hideMainButton}
        progressValue={popupData.progressValue}
      >
        {popupData.children}
      </PopUp>
    </ul>
  );
}
